import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { PatientProfile } from "src/api/types";

interface Props {
  patient: PatientProfile;
}

const PriorAuthConsent = ({ patient }: Props) => {
  const gavePriorAuthConsent = useMemo(
    () => patient.prior_auth_consent,
    [patient.prior_auth_consent],
  );

  if (!gavePriorAuthConsent) return null;

  return (
    <Stack gap={1}>
      <Typography fontWeight={600}>{"Prior Auth Consent"}</Typography>
      <Typography fontStyle={"italic"}>
        {
          "Patient has given MiPaz Medical P.A. (HolaVida) permission to submit prior authorizations to patient's insurance on the patient's behalf."
        }
      </Typography>
    </Stack>
  );
};

export default PriorAuthConsent;
